@if (partners) {
  <form class="form-example mt-3">
    <div nxLayout="grid">
      <div nxRow="">
        <div nxCol="12">
          @if (editableType != 'partner') {
            <nx-formfield label="{{'contract.point' | caption}}">
              <input type="text" nxInput disabled
                [value]="model.partner?.name"/>
              </nx-formfield>
            }
            @if (editableType == 'partner') {
              <nx-formfield label="{{'contract.partner' | caption}}">
                <nx-dropdown
                  name="partnerId"
                  [(ngModel)]="model.partnerId"
                  (ngModelChange)="updatePartner($event)"
                  >
                  @for (partner of partners; track partner) {
                    <nx-dropdown-item [value]="partner.id"> {{partner.name}}</nx-dropdown-item>
                  }
                </nx-dropdown>
              </nx-formfield>
            }
          </div>
          <div nxCol="12,12,12,6">
            @if (editableType != 'measuringPoint') {
              <nx-formfield label="{{'contract.point' | caption}}">
                <input type="text" nxInput disabled
                  [value]="model.measuringPoint.name"/>
                </nx-formfield>
              }
              @if (editableType == 'measuringPoint') {
                <nx-formfield label="{{'contract.measuringPoint' | caption}}">
                  <nx-dropdown
                    name="measuringPointId"
                    [(ngModel)]="model.measuringPointId"
                    (ngModelChange)="updatePoint($event)"
                    >
                    @for (point of measuringPoints; track point) {
                      <nx-dropdown-item [value]="point.id"> {{point.name}}</nx-dropdown-item>
                    }
                  </nx-dropdown>
                </nx-formfield>
              }
            </div>
            <div nxCol="12,12,12,6">
              @if (editableType != 'measuringDevice') {
                <nx-formfield label="{{'contract.device' | caption}}">
                  <input type="text" nxInput disabled
                    [value]="model.measuringDevice.uuId"/>
                  </nx-formfield>
                }
                @if (editableType == 'measuringDevice') {
                  <nx-formfield label="{{'contract.device' | caption}}">
                    <nx-dropdown
                      name="measuringDeviceId"
                      [(ngModel)]="model.measuringDeviceId"
                      (ngModelChange)="updateDevice($event)"
                      >
                      @for (device of measuringDevices; track device) {
                        <nx-dropdown-item [value]="device.id"> {{device.uuId}}</nx-dropdown-item>
                      }
                    </nx-dropdown>
                  </nx-formfield>
                }
              </div>
              @if (editableType != 'date') {
                <div nxCol="12,12,12,6">
                  <nx-formfield label="{{'contract.start' | caption}}">
                    <input type="text" nxInput disabled
                      [value]="model.start"/>
                    </nx-formfield>
                  </div>
                  <div nxCol="12,12,12,6">
                    <nx-formfield label="{{'contract.end' | caption}}">
                      <input type="text" nxInput disabled
                        [value]="model.end"/>
                      </nx-formfield>
                    </div>
                  }
                  @if (editableType == 'config') {
                    <div nxCol="12,12,12,6">
                      <nx-formfield label="{{'addon.chartType' | caption}} *">
                        <nx-multi-select [(ngModel)]="model.chartTypes" name="chartTypes"
                          [options]="chartTypes" selectValue="id" selectLabel="label"
                        ></nx-multi-select>
                      </nx-formfield>
                    </div>
                  }
                  @if (editableType == 'date') {
                    <div nxCol="12,12,12,6">
                      <nx-formfield label="{{'contract.start' | caption}}">
                        <input name="start" type="local-datetime" nxInput nxDatefield [datepicker]="startDatePicker"
                          [min]="firstStartDenyDate"
                          [max]="modelEnd"
                          [(ngModel)]="model.start" required/>
                          <nx-datepicker-toggle
                            [for]="startDatePicker"
                            nxFormfieldSuffix
                          ></nx-datepicker-toggle>
                          <nx-datepicker #startDatePicker></nx-datepicker>
                        </nx-formfield>
                      </div>
                      <div nxCol="12,12,12,6">
                        <nx-formfield label="{{'contract.end' | caption}}">
                          <input name="end" type="datetime" nxInput nxDatefield [datepicker]="endDatePicker"
                            [min]="modelStart"
                            [max]="firstEndDenyDate"
                            [(ngModel)]="model.end" required/>
                            <nx-datepicker-toggle
                              [for]="endDatePicker"
                              nxFormfieldSuffix
                            ></nx-datepicker-toggle>
                            <nx-datepicker #endDatePicker></nx-datepicker>
                          </nx-formfield>
                        </div>
                      }
                    </div>
                  </div>
                </form>
              }
